let data = {};

onmessage = function (message) {
  const { searchText } = message.data.data;
  const trimmedSearchText = searchText.trim().toLowerCase();

  data = message.data.data;
  filterData(trimmedSearchText);
  const sortedFeatures = data.features.sort(
    (a, b) => -getHits(a.hits) + getHits(b.hits),
  );
  postMessage(sortedFeatures);
};

function filterData(text) {
  const words = text.split(" ").filter((word) => word.length > 0);
  let nameIsMatched = false,
    streetIsMatched = false,
    zipIsMatched = false;

  for (
    let featureIndex = 0;
    featureIndex < data.features.length;
    featureIndex++
  ) {
    data.features[featureIndex].hits = {};
    data.features[featureIndex].hits.name = [];
    data.features[featureIndex].hits.zip = [];
    data.features[featureIndex].hits.street = [];

    nameIsMatched = false;
    streetIsMatched = false;
    zipIsMatched = false;

    for (const word of words) {
      if (isHit(word, featureIndex, "name")) {
        nameIsMatched = true;
      }
      if (isHit(word, featureIndex, "zip")) {
        zipIsMatched = true;
      }
      if (isHit(word, featureIndex, "street")) {
        streetIsMatched = true;
      }
    }
    const countryIsMatched =
      data.country === "all" ||
      data.country === "All" ||
      data.country === data.features[featureIndex].properties.country;

    if (
      !countryIsMatched ||
      (!nameIsMatched && !streetIsMatched && !zipIsMatched && text.length !== 0)
    ) {
      data.features.splice(featureIndex, 1);
      featureIndex--;
    } else {
      if (nameIsMatched) {
        populateWords(featureIndex, "name");
      }

      if (zipIsMatched) {
        populateWords(featureIndex, "zip");
      }

      if (streetIsMatched) {
        populateWords(featureIndex, "street");
      }
    }
  }
}

function isHit(word, featureIndex, key) {
  const feature = data.features[featureIndex];
  const trimmedWord = word.toLowerCase();
  const nameIndex = feature.properties[key].toLowerCase().indexOf(trimmedWord);
  const isHit = nameIndex !== -1;
  if (isHit) {
    const startPosition = nameIndex;
    const endPosition = nameIndex + trimmedWord.length;

    indexPosition(featureIndex, key, startPosition, endPosition);
    return true;
  }

  return false;
}

function indexPosition(featureIndex, key, startPosition, endPosition) {
  const hits = data.features[featureIndex].hits[key];

  for (const [i, hit] of hits.entries()) {
    if (startPosition >= hit[0] && endPosition <= hit[1]) {
      return;
    }

    if (startPosition <= hit[0] && endPosition >= hit[1]) {
      data.features[featureIndex].hits[key][i][0] = startPosition;
      data.features[featureIndex].hits[key][i][1] = endPosition;
      return;
    }

    if (
      startPosition >= hit[0] &&
      startPosition <= hit[1] &&
      endPosition >= hit[1]
    ) {
      data.features[featureIndex].hits[key][i][1] = endPosition;
      return;
    }

    if (
      startPosition <= hit[0] &&
      endPosition >= hit[0] &&
      endPosition <= hit[1]
    ) {
      data.features[featureIndex].hits[key][i][0] = startPosition;
      return;
    }
  }

  data.features[featureIndex].hits[key] = [
    ...data.features[featureIndex].hits[key],
    [startPosition, endPosition],
  ];
}

function populateWords(featureIndex, key) {
  const words = data.features[featureIndex].hits[key].sort(
    (a, b) => a[0] - b[0],
  );
  let finalHTML = data.features[featureIndex].properties[key];
  words.map(
    (word, i) =>
      (finalHTML = `${finalHTML.slice(0, word[0] + i * 13)}<span>${finalHTML.slice(word[0] + i * 13, word[1] + i * 13)}</span>${finalHTML.slice(word[1] + i * 13)}`),
  );
  data.features[featureIndex].properties[key] = finalHTML;
}

function getHits(hits) {
  return Object.values(hits).reduce((acc, curr) => {
    if (curr.length === 0) {
      return acc;
    }

    const fieldHits = curr.reduce((fieldacc, fieldcurr) => {
      return fieldcurr[1] - fieldcurr[0] + fieldacc;
    }, 0);

    return acc + fieldHits;
  }, 0);
}
